import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const PurchaseSection = () => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.purchase")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit/purchase"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[]}
    />
  );
};

export default PurchaseSection;
